import { useState } from 'react';
import { useUpdateEffect } from 'react-use';

import { NumberPatternType } from '@dreryk/react-common';
import { NumberInput, StyledFlex } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import {
   MedicalDeviceOrderFormRegister,
   MedicalDeviceOrderFormSetValue,
   MedicalDeviceOrderFormWatch,
   MedicalDeviceOrderItemsPerMonthCountFormBeanPart,
   MedicalDeviceOrderTillLimitFormBeanPart,
} from '../medicalDeviceOrder.types';
import { isMedicalDeviceFieldRequired, shouldDisplayTillLimitField } from '../medicalDeviceOrder.utils';

import { TillLimitField } from './TillLimitField';

type ItemsPerMonthCountFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister<
      MedicalDeviceOrderItemsPerMonthCountFormBeanPart & MedicalDeviceOrderTillLimitFormBeanPart
   >;
   readonly watch: MedicalDeviceOrderFormWatch<MedicalDeviceOrderTillLimitFormBeanPart>;
   readonly setValue: MedicalDeviceOrderFormSetValue;
};

const ITEMS_PER_MONTH_MIN = 1;

export const ItemsPerMonthCountField = (props: ItemsPerMonthCountFieldProps): JSX.Element => {
   const [disabled, setDisabled] = useState<boolean>(false);
   const { register, watch, setValue } = props;
   const { device, tillLimit } = watch(['device', 'tillLimit']);
   const itemsLimit = device?.limit;

   useUpdateEffect(() => {
      if (tillLimit) {
         setValue('itemsPerMonthCount', itemsLimit);
         setDisabled(true);
         return;
      }
      setDisabled(false);
   }, [tillLimit]);
   return (
      <StyledFlex gap={'12px'} direction={'column'}>
         <NumberInput
            testId={'itemsPerMonthCount'}
            label={medicalDevicesTranslationKeys.fields.itemsPerMonthCount}
            controller={register('itemsPerMonthCount', {
               required: isMedicalDeviceFieldRequired(props.watch, 'itemsPerMonthCount'),
            })}
            disabled={disabled || itemsLimit === 1}
            defaultValue={itemsLimit}
            max={itemsLimit}
            min={ITEMS_PER_MONTH_MIN}
            pattern={NumberPatternType.POSITIVE_INTEGER}
         />
         {shouldDisplayTillLimitField(register, itemsLimit ?? 0) ? <TillLimitField register={register} /> : null}
      </StyledFlex>
   );
};
